import { getEngine as tealiumEngine } from '../../engines/tealium';
import { getEngine as nielsenMediametrie } from '../../engines/nielsenMediametrie';
import { getEngine as nielsenStatic } from '../../engines/nielsenStatic';
import { getEngine as fireboltMetrics } from '../../engines/fireboltMetrics';
import { getEngine as youboraEngine } from '../../engines/youbora';
import { getEngine as newRelicEngine } from '../../engines/newrelic';

// NOTE: creating engines descriptors to allow multiple calls of the "getEngines" without creating of additional instances of the descriptors
const engines = [
  tealiumEngine(),
  nielsenMediametrie(),
  nielsenStatic(),
  fireboltMetrics(),
  youboraEngine(),
  newRelicEngine(),
];

export const getEngines = () => engines;
